import { TableRow, TableCell, Typography } from '@mui/material';

import { FCheckbox } from '../../../base';
import { FORTA_GRAY4, FORTA_BLUE } from '../../../../utils/colors';
import { formatEntityId, usDollarFormatter } from '../../../../helpers';
import { ENTITY_PREFIX } from '../../../../constants';

export interface IInvoiceHistoryTableRowData {
  selected?: boolean;
  invoice_id: number | null;
  is_invoiceable: boolean;
  datesOfService: string;
  id: number;
  code: string;
  patient_responsibility: number;
}

const commonRowStyles = {
  fontWeight: '400',
  lineHeight: '21px',
  color: FORTA_GRAY4,
};

interface IInvoiceHistoryTableRowProps {
  data: IInvoiceHistoryTableRowData;
  onSelectRow: (selected: boolean, claimId: number) => void;
}

const InvoiceHistoryTableRow = ({ data, onSelectRow }: IInvoiceHistoryTableRowProps) => {
  const {
    selected = false,
    is_invoiceable,
    invoice_id,
    datesOfService,
    id,
    code,
    patient_responsibility,
  } = data;
  const isRowDisabled = Boolean(invoice_id !== null) || !is_invoiceable;
  return (
    <TableRow key={id} sx={{ opacity: isRowDisabled ? 0.5 : 1 }} data-testid={`invoiceRow_${id}`}>
      <TableCell>
        <FCheckbox
          iconStyles={{
            boxShadow: 'none',
            border: isRowDisabled ? 'none' : `1px solid ${FORTA_BLUE.light2}`,
          }}
          coloredBackground
          disabled={isRowDisabled}
          checked={selected}
          onChange={(e) => onSelectRow(e.target.checked, data.id)}
        />
      </TableCell>
      <TableCell sx={commonRowStyles}>
        <Typography>{`${is_invoiceable ? 'Yes' : 'No'}`}</Typography>
      </TableCell>
      <TableCell sx={commonRowStyles}>{datesOfService}</TableCell>
      <TableCell>
        <Typography
          sx={{
            color: FORTA_BLUE.primary,
            textDecoration: 'underline',
            cursor: 'pointer',
            width: 'fit-content',
          }}
          onClick={() => {
            window.open(`/billings/claims/${id}/`, '_blank');
          }}
        >
          {formatEntityId(id, ENTITY_PREFIX.Claim)}
        </Typography>
      </TableCell>
      <TableCell sx={commonRowStyles}>{code}</TableCell>
      <TableCell sx={commonRowStyles}>
        {usDollarFormatter.format(patient_responsibility ?? 0)}
      </TableCell>
    </TableRow>
  );
};

export default InvoiceHistoryTableRow;
